<!--
2021-07-19 CHP 修改底部菜单为 Promotion\Gift\Home\Deposit\Account
2021-10-10 CHP 国际化
2021-11-13 CHP 增加Notice
2022-11-05 HHY 实现Affiliate和Agent动态转换
-->
<template>
  <div class="footerGuide">
    <div class="guideItem"  v-for="(item, i) in footerList" :key="i"
         @click="gotoRoute(item.name, i)">
      <img :src="fetchCurrentRoute(item.name)?item.srcAct:item.src" alt="" style="width: 30px; height: 30px">
      <div class="label" :class="{'labelAct': fetchCurrentRoute(item.name)}">{{ item.label }}</div>
      <div class="bubble" v-if="item.name === 'Deposit' && bubbleSetting !== ''">
        <span>{{ $t('lang.account.depositBonus') }} ₹{{ separateThousandInteger(bubbleSetting) }}</span>
      </div>
      <div class="EarnRed_dot" v-if="todayShow && item.name === 'Earn' && $store.state.footerEarn"></div>
      <div class="EarnRed_dot" v-if="item.name === 'Support' && workOrderMessageCount !== 0"></div>
      <div class="EarnRed_dot" v-if="item.name === 'Promotion' && $store.state.ShowPromotionRedDot || shouldShowPromotionRedDot"></div>
      <div class="bubble2" v-if="item.name === 'Earn' && $store.state.ShowInviteRedDot">
        <span>{{ $t('lang.account.ClaimPrize')}}</span>
<!--        <span>{{ $t('lang.account.currencyType') + $store.state.footerEarn + $t('lang.footer.bubbles') }}</span>-->
      </div>
      <div v-if="item.name === 'Deposit' && bubbleSetting !== ''" class="bubble-before"/>
      <div v-if="item.name === 'Earn' && $store.state.ShowInviteRedDot" class="bubble-before2"/>
    </div>
    <GameIframe :gameInfo="gameInfo" v-if="showGame"/>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import request from '@/service'
import {separateThousand, LogUtils, separateThousandInteger, clickEvent} from '@/utils'
import home from '@/assets/images/footerGuide/home.svg'
import homeAct from '@/assets/images/footerGuide/homeAct.svg'
import agentAct from '@/assets/images/footerGuide/agentAct.svg'
import agent from '@/assets/images/footerGuide/agent.svg'
import affiliateAct from '@/assets/images/footerGuide/affiliateAct.svg'
import affiliate from '@/assets/images/footerGuide/affiliate.svg'
import promotion from '@/assets/images/footerGuide/promotion.svg'
import promotionAct from '@/assets/images/footerGuide/promotionAct.svg'
import deposit from '@/assets/images/footerGuide/deposit.svg'
import depositAct from '@/assets/images/footerGuide/depositAct.svg'
import support from '@/assets/images/footerGuide/support.svg'
import supportAct from '@/assets/images/footerGuide/supportAct.svg'
import GameIframe from '@/components/GameIframe/index'
import {Toast} from 'mint-ui'
import store from '../../store/store'
export default {
  name: 'FooterGuide',
  data () {
    return {
      shouldShowPromotionRedDot: false,
      InviteBet: false,
      isCallBack: false,
      isTwice: false,
      todayShow: false,
      footerList: [],
      workOrderMessageCount: 0,
      footerList1: [
        {
          label: this.$t('lang.footer.Home'),
          name: 'Home',
          src: home,
          srcAct: homeAct
        },
        {
          label: this.$t('lang.footer.Agent'),
          name: 'Agent',
          src: agent,
          srcAct: agentAct
        },
        {
          label: this.$t('lang.footer.Promotion'),
          name: 'Promotion',
          src: promotion,
          srcAct: promotionAct
        },
        {
          label: this.$t('lang.footer.Deposit'),
          name: 'Deposit',
          src: deposit,
          srcAct: depositAct
        },
        {
          label: this.$t('lang.footer.Support'),
          name: 'Support',
          src: support,
          srcAct: supportAct
        }
      ],
      footerList2: [
        {
          label: this.$t('lang.footer.Home'),
          name: 'Home',
          src: home,
          srcAct: homeAct
        },
        {
          label: this.$t('lang.footer.Affiliate'),
          name: 'Earn',
          src: affiliate,
          srcAct: affiliateAct
        },
        {
          label: this.$t('lang.footer.Promotion'),
          name: 'Promotion',
          src: promotion,
          srcAct: promotionAct
        },
        {
          label: this.$t('lang.footer.Deposit'),
          name: 'Deposit',
          src: deposit,
          srcAct: depositAct
        },
        {
          label: this.$t('lang.footer.Support'),
          name: 'Support',
          src: support,
          srcAct: supportAct
        }
      ],
      winnerList: [],
      fetchCurrency: {
        zh: '￥',
        en: '$',
        id: '₹'
      },
      separateThousand,
      showGame: false,
      gameInfo: {},
      winnerTimeout: null,
      winnerInterval: null,
      isAppCid: localStorage.getItem('isAppCid') === 'true',
      bubbleSetting: '',
      accountInfo: {},
      activity: {}
    }
  },
  watch: {
    '$store.state.giftShowRedCircle': {
      handler (item) {
        this.checkShowPromotionRedDot()
      },
      immediate: true
    },
    // 2022-03-27 CHP 监控语言切换更新菜单文字
    '$store.state.locale': function () {
      this.footerList1 = [
        {
          label: this.$t('lang.footer.Home'),
          name: 'Home',
          src: home,
          srcAct: homeAct
        },
        {
          label: this.$t('lang.footer.Agent'),
          name: 'Agent',
          src: agent,
          srcAct: agentAct
        },
        {
          label: this.$t('lang.footer.Promotion'),
          name: 'Promotion',
          src: promotion,
          srcAct: promotionAct
        },
        /* {
          label: 'Gift',
          src: gift,
          srcAct: gift
        }, */
        {
          label: this.$t('lang.footer.Deposit'),
          name: 'Deposit',
          src: deposit,
          srcAct: depositAct
        },
        {
          label: this.$t('lang.footer.Support'),
          name: 'Support',
          src: support,
          srcAct: supportAct
        }
      ]

      this.footerList2 = [
        {
          label: this.$t('lang.footer.Home'),
          name: 'Home',
          src: home,
          srcAct: homeAct
        },
        {
          label: this.$t('lang.footer.Affiliate'),
          name: 'Earn',
          src: affiliate,
          srcAct: affiliateAct
        },
        {
          label: this.$t('lang.footer.Promotion'),
          name: 'Promotion',
          src: promotion,
          srcAct: promotionAct
        },
        {
          label: this.$t('lang.footer.Deposit'),
          name: 'Deposit',
          src: deposit,
          srcAct: depositAct
        },
        {
          label: this.$t('lang.footer.Support'),
          name: 'Support',
          src: support,
          srcAct: supportAct
        }
      ]
      this.setFootListNroute()
    }
  },
  computed: {
    fetchCurrentRoute () {
      return (label) => {
        if (label === 'Deposit' && (this.$route.name === 'Deposit' || this.$route.name === 'Withdraw' || this.$route.name === 'Account')) {
          return true
        } else {
          return label === this.$route.name
        }
      }
    }
  },
  components: {
    GameIframe
  },
  mounted () {
    // this.getRedDotInviteBet()
    if (localStorage.getItem('userInfo')) {
      if (localStorage.getItem('bubbleTIme')) {
        const isSameDay = LogUtils.isSameDay(Date.now(), localStorage.getItem('bubbleTIme') * 1)
        if (!isSameDay) {
          this.todayShow = true
        }
      } else {
        this.todayShow = true
      }
    }
    this.getDepositActivity()
    this.fetchAccount()
    this.getMessageCount()
  },
  beforeDestroy () {
    clearTimeout(this.winnerTimeout)
    clearInterval(this.winnerInterval)
  },
  methods: {
    separateThousandInteger,
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute'
    }),
    checkShowPromotionRedDot () {
      const giftModel = localStorage.getItem('SevenDayGiftModel')
      this.shouldShowPromotionRedDot = giftModel === 'versionC' && this.$store.state.giftShowRedCircle && this.$store.state.isHavePromotionVersionC
    },
    getMessageCount () {
      if (!localStorage.getItem('userInfo')) {
        return false
      }
      let url = 'innovation/ticket/unread/message/count'
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')).UserId
      }
      request('post', url, data, false).then(res => {
        if (res) {
          this.workOrderMessageCount = res.Count
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getRedDotInviteBet () {
      const url = 'innovation/activity/show/red_dot'
      const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
      const data = {
        userId: userInfo.UserId || ''
      }
      request('post', url, data).then(res => {
        if (res) {
          this.InviteBet = res.InviteBet
        }
      })
    },
    getDepositActivity () { // 2023-04-13 hp 更新周六会员日充值赠送页面效果
      const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
      if (localStorage.getItem('userInfo')) {
        const url = '/innovation/account/get/deposit/activity'
        const data = {
          userId: userInfo.UserId || ''
        }
        request('post', url, data, false).then(res => {
          if (res) {
            this.activity = res
            if (res.FirstDeposit) {
              store.commit('setUserFirstDeposit', true)
            }
            if (res.FirstDeposit || res.TwiceDeposit || res.ThirdDeposit || res.CallbackDeposit || res.MembersDayDeposit || res.SundayDeposit) {
              this.getBubbleSetting()
            }
          }
        })
      }
    },
    fetchWinners (num) {
      request('post', '/innovation/home/getrealtimewinners', {
        Number: num || 1,
        Culture: 'id'
        // Culture: localStorage.getItem('locale')
      }, true).then(res => {
        if (res) {
          this.winnerList = this.winnerList.concat(res.Winners)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    randomTimeout (index) {
      this.winnerTimeout = setTimeout(() => {
        this.$refs.winnerContent.style.top = -25 * index + 'px'
        this.fetchWinners(1)
      }, Math.random() * 10000)
    },
    fetchGame (game) {
      const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
      if (userInfo && this.$store.state.banUserId.includes(userInfo.UserId)) {
        Toast(this.$t('lang.home.gameMaintenancePrompt'))
        return
      }
      const url = '/innovation/game/getgameurl'
      const data = {
        userId: userInfo.UserId || '',
        gameCode: game.GameCode,
        gameProviderId: game.GameProviderId,
        deviceWidth: document.body.clientWidth,
        lang: localStorage.getItem('locale')
      }
      request('post', url, data).then(res => {
        if (res.Url) {
          this.gameInfo = {
            gameUrl: res.Url,
            gameImg: game.ThumbnailUrl,
            gameName: game.GameNameEn
          }
          this.showGame = true
        } else {
          Toast('Fail')
        }
      })
    },
    /****
     *
     * @param label
     * 2021-07-31 C007 点击当前Label时，刷新当前页
     * 2021-08-03 C007 点击Promotion改为弹框显示
     */
    gotoRoute (label) {
      this.$router.beforeEach((to, from, next) => {
        if (from.name === 'Promotion') {
          this.checkShowPromotionRedDot()
        }
        next()
      })
      if (label === 'Promotion' || label === 'Support') {
        clickEvent({EventNameEN: 'footer' + label})
      }
      const userInfo = localStorage.getItem('userInfo')
      if (userInfo && label === 'Home' && this.$store.state.showGame) {
        this.$store.commit('setGameInfo', {})
        this.$store.commit('setShowGame', false)
      } else if (userInfo && label === 'Earn' && localStorage.getItem('bubbleTIme')) {
        const isSameDay = LogUtils.isSameDay(Date.now(), localStorage.getItem('bubbleTIme') * 1)
        if (!isSameDay) {
          localStorage.setItem('bubbleTIme', Date.now())
        }
      } else if (userInfo && label === 'Earn' && !localStorage.getItem('bubbleTIme')) {
        localStorage.setItem('bubbleTIme', Date.now())
      }
      this.setCurrentRoute(label)
      this.$router.push('/' + label)
    },
    close () {
      this.showGame = false
    },
    fetchAccount () {
      const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null
      if (userInfo) {
        const url = '/innovation/account/getuseraccount'
        const data = {
          userId: userInfo.UserId
        }
        request('post', url, data).then(res => {
          this.accountInfo = res
          this.setFootListNroute()
          this.checkShowPromotionRedDot()
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.setFootListNroute()
      }
    },
    getBubbleSetting () {
      const url = 'innovation/home/get-system-settings'
      let cid = localStorage.getItem('cid') // （注：从localstorage取出cid）
      const data = {IsApp: 1, CampaignId: cid}
      request('post', url, data).then(res => {
        store.commit('setMembersDayDeposit', false)
        console.log(res)
        if (this.activity.FirstDeposit) {
          this.bubbleSetting = res.FirstDepositMaxReward
        } else if (this.activity.TwiceDeposit) {
          this.bubbleSetting = res.TwiceDepositMaxReward
        } else if (this.activity.ThirdDeposit) {
          this.bubbleSetting = res.ThirdDepositMaxReward
        } else if (this.activity.CallbackDeposit) {
          this.bubbleSetting = res.CallbackDepositMaxReward
        } else if (this.activity.MembersDayDeposit) {
          store.commit('setMembersDayDeposit', true)
          this.bubbleSetting = res.MembersDayDepositMaxReward
        } else if (this.activity.SundayDeposit) {
          this.bubbleSetting = res.SundayDepositMaxReward
        }
        store.commit('setInviteeObj',
          {
            sevenDayReward: res.SevenDayReward,
            inviteeMaxReward: res.DefaultCampaignIdFirstDepositMaxReward,
            InviteeReward: res.InviteeReward
          })
      }).catch(err => {
        console.log(err)
        this.bubbleSetting = ''
      })
    },
    setFootListNroute () { // 2022-11-05 HHY 从mounted中迁移到这里
      if (this.accountInfo.IsAgent) {
        this.footerList = this.footerList1
      } else {
        this.footerList = this.footerList2
      }
      this.footerList.forEach((item, i) => {
        if (item.label === this.$route.name) {
          this.setCurrentRoute(item.label)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.footerGuide {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 70px;
  background-color: #212324;
  display: flex;
  justify-content: space-around;
  padding-top: 6px;
  text-align: center;
  z-index: 4;

  .guideItem {
    flex: 1;

    .label {
      font-size: 12px;
      color: #686868;
    }

    .labelAct {
      color: #F6D9AA;
    }

    position: relative;

    .bubble {
      position: absolute;
      top: -32px;
      left: 50%;
      transform: translate(-50%);
      width: max-content;
      padding: 6px;
      border-radius: 6px;
      font-size: 12px;
      color: #FFFFFF;
      white-space: nowrap;
      background: linear-gradient(#FD8F50, #CF1211);
      z-index: 5;
    }

    .bubble-before {
      position: absolute;
      top: -11px;
      left: 8.889vw;
      height: 10px;
      width: 10px;
      background: #CF1211;
      transform: rotate(45deg);
      z-index: 4;
    }

    .EarnRed_dot {
      height: 2.5vw;
      width: 2.5vw;
      background: #F23042;
      position: absolute;
      top: 0vw;
      left: 13vw;
      border-radius: 100vw;
    }

    .bubble2 {
      position: absolute;
      top: -32px;
      left: 50%;
      transform: translate(-50%);
      width: max-content;
      padding: 6px;
      border-radius: 6px;
      font-size: 12px;
      color: #FFFFFF;
      white-space: nowrap;
      background: linear-gradient(#FD8F50, #CF1211);
      text-align: center;
      z-index: 5;
    }

    .bubble-before2 {
      position: absolute;
      top: -11px;
      left: 8.889vw;
      height: 10px;
      width: 10px;
      background: #CF1211;
      transform: rotate(45deg);
      z-index: 4;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterGuide/index.vue